import React, { useEffect, useState , useContext, use } from "react";
import HeroSlider from "./components/slidder";
/* import ProvinceMap from "./components/provincemap"; */
import { Link } from "react-router-dom";
import api, { AuthContext, BACKEND_URL } from "./util/api";
import Map from "./components/map";
import BlogNewsletter from "./blog/news";

export default function Home() {
   

  const [offset, setOffset] = useState(0);
  const [pages, setPages] = useState([]);



  const [modalOpen, setModalOpen] = useState(false);
  const [activePage, setActivePage] = useState(null);
  const PREVIEW_LEN = 200;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
   const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const stripHtml = (html = "") => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };


  // ...existing code...

  const fetchPages = async () => {
    try {

      const response = await api.get("/pages");
      setPages(response.data.pages);


    } catch (error) {
      console.error("Error fetching pages:", error);
    }
  };

  useEffect(() => {
   
    fetchPages();
  }, []);



  useEffect(() => {



    document.body.style.background = "#f6f9ff";

    const onScroll = () => setOffset(window.scrollY);
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);

  }, []);

  return (
    <>
      <section style={{ marginTop: "2cm" }}>

        {/* HERO SLIDER */}
        <HeroSlider />

      </section>



      {/* ABOUT YOUTH */}
      <section style={styles.section}>
        <div style={styles.sectionInner}>


               
                  {pages.map((page, idx) => {
                    const text = stripHtml(page.body);
                    const isLong = text.length > PREVIEW_LEN;
        
                    return (
                      <React.Fragment key={page.id ?? idx}>
                        {isMobile ? (
                          <>
                            <div /* style={styles.aboutRight} */>
                              <div style={styles.previewCard}>
                                <img
                                  src={BACKEND_URL + page.image}
                                  alt=""
                                  style={styles.previewImg}
                                />
                              </div>
                            </div>

                            <div style={styles.aboutLeft}>
                              <h2 style={styles.sectionTitle}>{page.title}</h2>
                              <div style={styles.sectionText}>
                                {isLong ? (
                                  <>
                                    <div>{text.substring(0, PREVIEW_LEN)}...</div>
                                    <button
                                      style={styles.viewMoreBtn}
                                      onClick={() => {
                                        setActivePage(page);
                                        setModalOpen(true);
                                      }}
                                    >
                                      View more
                                    </button>
                                  </>
                                ) : (
                                  <div dangerouslySetInnerHTML={{ __html: page.body }} />
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={styles.aboutLeft}>
                              <h2 style={styles.sectionTitle}>{page.title}</h2>
                              <div style={styles.sectionText}>
                                {isLong ? (
                                  <>
                                    <div>{text.substring(0, PREVIEW_LEN)}...</div>
                                    <button
                                      style={styles.viewMoreBtn}
                                      onClick={() => {
                                        setActivePage(page);
                                        setModalOpen(true);
                                      }}
                                    >
                                      View more
                                    </button>
                                  </>
                                ) : (
                                  <div dangerouslySetInnerHTML={{ __html: page.body }} />
                                )}
                              </div>
                            </div>

                            <div style={styles.aboutRight}>
                              <div style={styles.previewCard}>
                                <img
                                  src={BACKEND_URL + page.image}
                                  alt=""
                                  style={styles.previewImg}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
     


         
       


          {/* Modal / Popup for full page body */}
          {modalOpen && activePage && (
            <div
              role="dialog"
              aria-modal="true"
              style={styles.modalOverlay}
              onClick={() => setModalOpen(false)}
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  aria-label="Close"
                  onClick={() => setModalOpen(false)}
                  style={styles.closeBtn}
                >
                  ×
                </button>
                <h2>{activePage.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: activePage.body }} />
              </div>
            </div>
          )}




        </div>
      </section>



      <section>
          {/* BLOG & NEWSLETTER */}
      
       
          <BlogNewsletter   margin="0cm"  type = "article" />

      </section>

      <hr/>


      <section>
          {/* BLOG & NEWSLETTER */}
         
       
          <BlogNewsletter   margin="0cm" type = "sermon" />

      </section>




      {/* PROVINCE MAP */}
      <section>
        <Map />
      </section>



      {/* FEATURES */}
      {/*   <section style={styles.featuresSection}>

        <h2 style={styles.featuresHeading}>
          Youth Activities
        </h2>

        <p style={styles.featuresSub}>
          Exciting programs designed to empower the next generation.
        </p>



        <div style={styles.featuresGrid}>

          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🙌</div>

            <h3 style={styles.featureTitle}>
              Worship Nights
            </h3>

            <p style={styles.featureText}>
              Powerful praise and worship gatherings bringing youth together
              in God's presence.
            </p>
          </div>



          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>📚</div>

            <h3 style={styles.featureTitle}>
              Bible Study
            </h3>

            <p style={styles.featureText}>
              Deep biblical teachings designed to build strong spiritual
              foundations.
            </p>
          </div>



          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🤝</div>

            <h3 style={styles.featureTitle}>
              Outreach
            </h3>

            <p style={styles.featureText}>
              Reaching communities through love, service, and evangelism.
            </p>
          </div>

        </div>

      </section> */}





    </>
  );
}



const styles = {

  section: {
    padding: "80px 30px",
    background: "#ffffff"
  },

  sectionInner: {
    maxWidth: "1200px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "40px"
  },

  aboutLeft: {
    flex: "1",
    minWidth: "280px"
  },

  aboutRight: {
    flex: "1",
    display: "flex",
    justifyContent: "center"
  },

  sectionTitle: {
    fontSize: "32px",
    fontWeight: "900",
    color: "#0A3D62",
    marginBottom: "10px"
  },

  sectionText: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#4a5a6a",
    marginBottom: "20px"
  },

  learnBtn: {
    padding: "12px 18px",
    background: "#ff4d6d",
    color: "#fff",
    borderRadius: "10px",
    textDecoration: "none",
    fontWeight: "bold"
  },

  previewCard: {
    width: "100%",
    maxWidth: "420px",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    position: "relative"
  },

  previewImg: {
    width: "100%",
    height: "300px",
    objectFit: "contain"
  },



  viewMoreBtn: {
    marginTop: 10,
    padding: "8px 12px",
    background: "#0A3D62",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer"
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 4000
  },
  modalContent: {
    maxWidth: "900px",
    width: "90%",
    maxHeight: "85vh",
    overflowY: "auto",
    background: "#fff",
    padding: 24,
    borderRadius: 12,
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    position: "relative"
  },
  closeBtn: {
    position: "absolute",
    top: 8,
    right: 10,
    border: "none",
    background: "transparent",
    fontSize: 24,
    cursor: "pointer"
  },






  previewBadge: {
    position: "absolute",
    bottom: "15px",
    left: "15px",
    background: "#ffffff",
    padding: "8px 12px",
    borderRadius: "8px",
    fontWeight: "bold"
  },



  featuresSection: {
    padding: "70px 30px",
    background: "#f7fbff",
    textAlign: "center"
  },

  featuresHeading: {
    fontSize: "30px",
    fontWeight: "900",
    color: "#0A3D62"
  },

  featuresSub: {
    marginBottom: "40px",
    color: "#6a7a8a"
  },

  featuresGrid: {
    maxWidth: "1100px",
    margin: "auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: "25px"
  },

  featureCard: {
    background: "#fff",
    padding: "25px",
    borderRadius: "15px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    transition: "0.3s",
    cursor: "pointer"
  },

  featureIcon: {
    fontSize: "35px",
    marginBottom: "10px"
  },

  featureTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px"
  },

  featureText: {
    color: "#5a6a7a",
    fontSize: "14px"
  },



  ctaSection: {
    padding: "60px 30px",
    background: "linear-gradient(120deg,#ff4d6d,#ff758f)",
    color: "#fff"
  },

  ctaInner: {
    maxWidth: "1100px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px"
  },

  ctaTitle: {
    fontSize: "26px",
    fontWeight: "900"
  },

  ctaDesc: {
    opacity: "0.9"
  },

  ctaButtons: {
    display: "flex",
    gap: "10px"
  },

  ctaPrimary: {
    padding: "12px 20px",
    background: "#fff",
    color: "#ff4d6d", 
    borderRadius: "10px",
    textDecoration: "none",
    fontWeight: "bold"
  },

  ctaSecondary: {
    padding: "12px 20px",
    border: "2px solid #fff",
    borderRadius: "10px",
    textDecoration: "none",
    color: "#fff"
  }



};